import { Keyway } from '@overtur-monorepo/keying-shared'
import { Injectable } from '@angular/core'
import { BehaviorSubject } from 'rxjs'
import { Book } from '../models/dev.test.models'

@Injectable({
  providedIn: 'root',
})
export class KeyingLibraryService {
  constructor() {}

  selectedBook = new BehaviorSubject<Book>(null)
  selectedBook$ = this.selectedBook.asObservable()

  selectedKeySectionSubject = new BehaviorSubject<Keyway>(null)
  selectedKeySection$ = this.selectedKeySectionSubject.asObservable()

  selectBook(selectedBook: Book) {
    this.selectedBook.next(selectedBook)
  }

  emitKeySection(selectedKeySection: Keyway) {
    this.selectedKeySectionSubject.next(selectedKeySection)
  }
}
